import configs from "./configs";

const AUTH_HINT_TTL_MS = 12 * 60 * 60 * 1000;
const SAFE_COOKIE_PREFIX_PATTERN = /^[A-Za-z0-9_-]+$/;

function normalizeCookiePrefix(value) {
  const trimmed = typeof value === "string" ? value.trim().replace(/^_+|_+$/g, "") : "";
  return SAFE_COOKIE_PREFIX_PATTERN.test(trimmed) ? trimmed : "";
}

export function getDashboardAuthHintCookieName() {
  const configuredPrefix =
    typeof process !== "undefined" &&
    process.env &&
    Object.prototype.hasOwnProperty.call(process.env, "AUTH_COOKIE_PREFIX")
      ? process.env.AUTH_COOKIE_PREFIX
      : configs.AUTH_COOKIE_PREFIX;
  const prefix = normalizeCookiePrefix(configuredPrefix);
  return prefix ? `${prefix}_auth_hint` : "auth_hint";
}

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  return (
    document.cookie
      .split(";")
      .map(part => part.trim())
      .find(part => part.startsWith(prefix))
      ?.slice(prefix.length) || null
  );
}

export function readDashboardAuthHint(now = Date.now()) {
  const raw = readCookie(getDashboardAuthHintCookieName());
  if (!raw) return null;

  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (
      parsed?.status !== "maybe_authenticated" ||
      !Number.isFinite(Number(parsed.expiresAt)) ||
      Number(parsed.expiresAt) <= now
    ) {
      return null;
    }

    return {
      status: "maybe_authenticated",
      displayName: typeof parsed.displayName === "string" ? parsed.displayName.trim() : undefined,
      expiresAt: Number(parsed.expiresAt)
    };
  } catch (_) {
    return null;
  }
}

export function hasDashboardAuthHint(now = Date.now()) {
  return Boolean(readDashboardAuthHint(now));
}

function writeCookie(name, value, expiresAt) {
  if (typeof document === "undefined") return;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}; expires=${new Date(expiresAt).toUTCString()}; path=/; SameSite=Lax`;
}

export function writeDashboardAuthHint({ displayName } = {}, now = Date.now()) {
  const hint = {
    status: "maybe_authenticated",
    displayName:
      typeof displayName === "string" && displayName.trim()
        ? displayName.trim()
        : undefined,
    expiresAt: now + AUTH_HINT_TTL_MS
  };

  writeCookie(getDashboardAuthHintCookieName(), JSON.stringify(hint), hint.expiresAt);
}

export function clearDashboardAuthHint() {
  writeCookie(getDashboardAuthHintCookieName(), "", 0);
}
